import { render, staticRenderFns } from "./Clientes.vue?vue&type=template&id=157387af&scoped=true"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"
import style0 from "./Clientes.vue?vue&type=style&index=0&id=157387af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157387af",
  null
  
)

export default component.exports